module.exports = __webpack_public_path__ + "fonts/LatoLatin-Thin.a57863f.woff2";